import { ref } from 'vue'

import {
  listDeviceProjectCopies,
  type DeviceProjectCopy,
} from '@/services/offlineLibrary'

const deviceProjects = ref<DeviceProjectCopy[]>([])

export function useOfflineLibrary() {
  async function refreshDeviceProjects(): Promise<void> {
    deviceProjects.value = await listDeviceProjectCopies()
  }

  return {
    deviceProjects,
    refreshDeviceProjects,
  }
}
